import { Text } from '@innovationdepartment/proxima-ui';
import { formatNumberToCommaSeparated } from 'utils/formatNumber';
import type { BrandProductCellRendererComponentProps } from '../types';

const BrandProductsItemsPurchased = (
  props: BrandProductCellRendererComponentProps<'itemsPurchased'>
) => {
  const { value } = props;

  return <Text variant="table1">{formatNumberToCommaSeparated(+value)}</Text>;
};

export default BrandProductsItemsPurchased;
